import { MappedClass, MappedProperty } from '@h5s/util-object';
import { ZPrinterDeviceType } from './z-printer-device-type';
import { ZPrinterManufacturer } from './z-printer-paper-manufacturer';
import { ZPrinterPaperSize } from './z-printer-paper-size';

@MappedClass()
export class ZPrinterConfiguration {
  @MappedProperty()
  id: string;

  @MappedProperty()
  name: string;

  @MappedProperty()
  ip: string;

  @MappedProperty()
  port: number;

  @MappedProperty()
  device_type: ZPrinterDeviceType;

  @MappedProperty()
  paper_size: ZPrinterPaperSize;

  @MappedProperty()
  manufacturer: ZPrinterManufacturer;

  @MappedProperty()
  status: string;

  @MappedProperty()
  inactive: boolean | null;

  @MappedProperty()
  is_mf: boolean;

  @MappedProperty()
  lottery_enabled_on_next_document: boolean;

  @MappedProperty()
  is_printer_supported: boolean;

  @MappedProperty()
  vat_table: string;

  @MappedProperty()
  fw_version?: string;

  @MappedProperty()
  serial_number?: string;

  @MappedProperty()
  created_at: string;

  @MappedProperty()
  created_by?: string | null;

  @MappedProperty()
  last_modified_at: string;

  @MappedProperty()
  last_modified_by?: string | null;

  @MappedProperty()
  deleted_at?: string | null;

  @MappedProperty()
  deleted_by?: string | null;

  @MappedProperty()
  row_version: number;

  @MappedProperty()
  paper_over?: boolean | null;

  @MappedProperty()
  cover_open?: boolean | null;
}
